export var StepperStates = {
    Completed: "completed",
    Active: "active",
    Disabled: "disabled",
};
export var StepperDefaultPropsValues = {
    nonLinear: false,
    completedStep: undefined,
};
